import { useEffect } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useRequest } from 'domain/core/hooks/useRequest';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { TUpdate } from 'domain/types';

export const PROFILE_NOTIFICATIONS_PER_PAGE = 5;

export const useGetProfileNotifications = () => {
  const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );
  const profileNotificationsData: any = useCS(
    GlobalConfigContext,
    globalConfigSelectors.profileNotificationsData
  );

  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getProfileNotifications = (
    page: number = 1,
    limit: number = profileNotificationsData?.limit || PROFILE_NOTIFICATIONS_PER_PAGE,
    successFunction?: any
  ) => {
    const reqUrl = `/api/v1/notifications?limit=${limit}&page=${page}`;
    send({}, reqUrl).then(() => {
      if (successFunction) successFunction();
    });
  };

  useEffect(() => {
    if (isLoading || !data || error) return;
    if (globalUpdate) {
      globalUpdate({
        profileNotificationsData: {
          ...data,
          // Сохраняем текущие данные, если они были добавлены через событие
          data: [
            ...profileNotificationsData.data.filter((item) => {
              return !data.data.some((newItem) => {
                return newItem.id === item.id;
              });
            }),
            ...data.data,
          ],
        },
      });
    }
  }, [data, isLoading, error]);

  return {
    getProfileNotifications,
    data,
    isLoading,
    error,
  };
};
